import GenericDataGrid from './GenericDataGrid';
import { useDataGrid, DataGridContextProvider } from './context';

export { useDataGrid, DataGridContextProvider }

export default GenericDataGrid;